<template>
<div class="change_car_info_container">
    <QS-h4-title title="换车记录" />
    <table-component
        :data="tableData"
        :columns="tableColumns"
        :total="pagination.total"
        :pageNum="pagination.pageNum"
        :pageSize="pagination.pageSize"
        :hideOnSinglePage="false"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        v-loading="loading"
        :paginationAlign="newTableComponentOptions.paginationAlign"
        :headerRowStyle="newTableComponentOptions.headerBackground"
    ></table-component>
</div>
</template>

<script setup>
import { ref } from 'vue'
import { changeCarDetailList } from '@/api/carManage/index.js'

const props = defineProps({
  orderId: {
    type: String,
    default: '',
  },
})

const tableData = ref([])
const tableColumns = [
  {
    label: '原车牌号',
    key: 'oldPlateNo',
  },
  {
    label: '新车牌号',
    key: 'newPlateNo',
  },
  {
    label: '换车原因',
    key: 'changeReason',
  },
  {
    label: '换车完成时间',
    key: 'finishTime',
  },
]
const newTableComponentOptions = {
  headerBackground: {
    backgroundColor: 'rgb(255,255,255)',
  },
  paginationAlign: 'right',
}
const loading = ref(false)
const pagination = ref({
  total: 0,
  pageNum: 1,
  pageSize: 10,
})

const currentChange = (pageNum) => {
  pagination.value.pageNum = pageNum
  getList()
}

const sizeChange = (pageSize) => {
  pagination.value.pageNum = 1
  pagination.value.pageSize = pageSize
  getList()
}

const getList = async () => {
  loading.value = true
  const { code, data } = await changeCarDetailList({
    orderId: props.orderId,
    pageSize: pagination.value.pageSize,
    pageNum: pagination.value.pageNum,
  })
  loading.value = false
  if (code === 1) {
    tableData.value = data.items
    pagination.value.total = data.totalNum ? data.totalNum : 0
  }
}

getList()

</script>
